// extracted by mini-css-extract-plugin
export var active = "_fn-2";
export var recordingDot = "_fn-1";
export var recordingIndicator = "_fn-0";